import { Box, LinearProgress, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import AddonsTableHead from './AddonsTableHead';
import AddonsTableRow from './AddonsTableRow';

export default function AddonsTable({ rows, loading, onEdit, onDelete, sentByAddon, sendingId, onSendNotification }) {
  return (
    <TableContainer sx={{ border: '1px solid #eee', borderRadius: 1 }}>
      {loading && <LinearProgress />}

      <Table size="small">
        <AddonsTableHead />

        <TableBody>
          {!rows || rows.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6}>
                <Box p={2}>No data</Box>
              </TableCell>
            </TableRow>
          ) : (
            rows.map((r) => (
              <AddonsTableRow
                key={r._id}
                row={r}
                onEdit={onEdit}
                onDelete={onDelete}
                previousNotification={sentByAddon?.get(String(r._id))}
                sendingNotification={sendingId === r._id}
                onSendNotification={onSendNotification}
              />
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
